"use client";

import { useGrowthBook } from "@growthbook/growthbook-react";

export function useFeatureFlag<T>(key: string, defaultValue: T): T {
  const growthbook = useGrowthBook();

  return growthbook.getFeatureValue(key, defaultValue) as T;
}
